import type { InstagramFeed } from '@peles/shared';

/**
 * Fetches the public Instagram feed for the landing page. This is a public
 * (unauthenticated) endpoint, so we use a plain fetch like the other landing
 * data calls rather than the authenticated API client.
 */
export async function getInstagramFeed(): Promise<InstagramFeed> {
  const res = await fetch('/api/v1/inquiries/public-instagram');
  if (!res.ok) {
    throw new Error('Failed to load Instagram feed');
  }
  return (await res.json()) as InstagramFeed;
}
